import { render } from "./index.vue?vue&type=template&id=0a621a95&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0a621a95&lang=css"
import "./index.vue?vue&type=style&index=1&id=0a621a95&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-0a621a95"

export default script